const login = {
  'login.loginTitle': 'تسجيل الدخول',
  'login.username.placeholder': 'رقم الحساب',
  'login.password.placeholder': 'كلمة المرور',
  'login.login': 'تسجيل الدخول',
  'login.msg.empty': 'لا يمكن أن يكون رقم الحساب أو كلمة المرور فارغين',
  'login.msg.loginfail': 'فشل تسجيل الدخول',
  'login.img': 'https://fe-static.cassmall.com/assets/images/20241207135447/login_bg_ar.jpg',
  'login.msg.accountEmpty': 'رقم الحساب فارغ',
};

export default login;
